/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Tool_Grants_Dialog_DescriptionInputs */



/**
* | output |
* | --- |
* | "Check a tool to let this member use it. Unchecking it takes the tool away again." |
*
* @param {Spaces_Tool_Grants_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_tool_grants_dialog_description = /** @type {((inputs?: Spaces_Tool_Grants_Dialog_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Tool_Grants_Dialog_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hake ein Tool an, damit dieses Mitglied es verwenden darf. Entfernst du den Haken, wird die Freigabe wieder entzogen.")
	return /** @type {LocalizedString} */ ("Check a tool to let this member use it. Unchecking it takes the tool away again.")
});